export default __webpack_public_path__ + "static/media/Romance.fa64e505.svg";